<div class="padding10">
  <span class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
    {{username}}
  </span>
  <br>
</div>
<div class="cursorPointer padding10 menu-item" (click)="openSettings()">
  <fa-icon [icon]="faGear" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
  <span class="font15 menu-item-text b-radius padding3"
    [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
    {{app.translations.GBL_lbl_SettingsText}}
  </span><br>
</div>
<div class="cursorPointer padding10 menu-item notification-user-menu" (click)="openNotifications()">
  <fa-icon [icon]="faBell" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
  <span class="font15 menu-item-text b-radius padding3"
    [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
    {{app.translations.NOT_lbl_Title}}
  </span><br>
</div>
<ng-template [ngIf]="!mobileView && (userRole == 'Administrator' || userRole == 'Dev')">
  <div class="cursorPointer padding10 menu-item" (click)="newReport()">
    <fa-icon [icon]="faArrowUpRightFromSquare" class="font15"
      [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
    <span class="font15 menu-item-text b-radius padding3"
      [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
      {{app.translations.GBL_lbl_ReportDsgnText}}
    </span><br>
  </div>
  <div class="cursorPointer padding10 menu-item" (click)="newDashboard()">
    <fa-icon [icon]="faGauge" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
    <span class="font15 menu-item-text b-radius padding3"
      [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
      {{app.translations.GBL_lbl_DashboardDsgnText}}
    </span><br>
  </div>
</ng-template>
<div class="cursorPointer padding10 menu-item" (click)="openFileImport()">
  <fa-icon [icon]="faArrowUpFromBracket" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
  <span class="font15 menu-item-text b-radius padding3"
    [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
    {{app.translations.IMP_lbl_Title}}
  </span><br>
</div>
<div *ngIf="!mobileView" class="cursorPointer padding10 menu-item" (click)="openCarouselList = !openCarouselList">
  <fa-icon [icon]="faGroupArrowsRotate" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
  <span class="font15 menu-item-text b-radius padding3"
    [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
    {{app.translations.GBL_lbl_DashboardCarousel}}
  </span><br>
  <ng-template [ngIf]="openCarouselList && dashboardCarouselList && dashboardCarouselList.length > 0">
    <ng-container *ngFor="let carousel of dashboardCarouselList;">
      <div class="cursorPointer padding10 menu-item">
          <span class="font14 menu-item-text b-radius padding3 cursorPointer" (click)="openDashboardCarousel(carousel.id)"
            [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
            {{carousel.name}}
          </span><br>
      </div>    
    </ng-container>
  </ng-template>
</div>
<div class="cursorPointer padding10 menu-item" (click)="logout()">
  <fa-icon [icon]="faRightFromBracket" class="font15" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'"></fa-icon>
  <span class="font15 menu-item-text b-radius padding3"
    [ngClass]="settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light'">
    {{app.translations.GBL_lbl_LogoutText}}
  </span><br>
</div>
<div class="cursorPointer padding10 menu-item" (click)="logout()">
  <!-- <span class="font12 cursorPointer cookie-policy" (click)="openCookiePolicy()"
    [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">{{app.translations.GBL_lbl_CookieLink}}</span> -->
  <span class="font12 version float-right" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
    v4.6.24
  </span>
</div>